<template>
  <div class="box2">
    <pageTitle title="Linux云计算运维行业发展迅猛" />
    <div class="content">
      <div class="top">
        <div class="box1">
          <img src="../../../assets/coursePage/linux/box2/ele.png" />
          <h1>全球90%以上的云服务器运行Linux</h1>
          <b>数据来源：worldmetrics</b>
        </div>
        <div class="box1">
          <img src="../../../assets/coursePage/linux/box2/ele.png" />
          <h1>全球排名100万的Web服务器中95%是基于Linux构建的</h1>
          <b>数据来源：worldmetrics</b>
        </div>
      </div>
      <div class="box2">
        <h1>运维⼯程师起步薪资17.25K，薪资优势明显</h1>
        <b>数据来源：Boss直聘7⽉统计数据</b>
      </div>
      <div class="box1">
        <img src="../../../assets/coursePage/linux/box2/ele.png" />
        <h1>国家力推，党政+八大行业实现软硬件全面国产化</h1>
        <p>
          ⾃2024年起，信创进入全面建设期，预计到2027年，党政及八大行业（教育、金融、电力、交通、能源、电信、医疗、航空航天）100%替换，实现国产化，信创运维将成为主要趋势
        </p>
        <b>数据来源：国家互联网信息⼯作室</b>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="less" scoped>
.box2 {
  background: url("../../../assets/coursePage/linux/box2/bg.png") no-repeat;
  background-size: 100% 100%;
  padding-top: 60px;
  .content {
    padding: 48px 30px 80px 30px;
    .top {
      display: flex;
      justify-content: space-between;

      .box1 {
        width: 334px;
        b {
          text-align: left;
        }
      }
    }
    .box1 {
      background: linear-gradient(
        270deg,
        rgba(212, 239, 255, 0.33) 0%,
        #d3e9ff 100%
      );
      border-radius: 20px;
      padding: 40px;
      position: relative;
      box-sizing: border-box;
      img {
        position: absolute;
        width: 180px;
        bottom: 0;
        right: 0;
      }
      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 26px;
        color: #001f3e;
        line-height: 36px;
        text-align: left;
        font-style: normal;
        position: relative;
        z-index: 2;
      }
      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;
        color: #385674;
        line-height: 34px;
        text-align: left;
        font-style: normal;
        margin-top: 16px;
         position: relative;
        z-index: 2;
      }
      b {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #7e96af;
        line-height: 24px;
        text-align: right;
        font-style: normal;
        margin-top: 24px;
        display: block;
         position: relative;
        z-index: 2;
      }
    }
    .box2 {
      background: url("../../../assets/coursePage/linux/box2/title-bg.png")
        no-repeat;
      background-size: 100% 100%;
      width: 100%;
      height: 164px;
      box-sizing: border-box;
      padding: 38px 40px 0 40px;
      margin: 22px 0;
      h1 {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 28px;
        color: #ffffff;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        margin-bottom: 22px;
      }
      b {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 24px;
        text-align: right;
        font-style: normal;
        margin-top: 22px;
        display: block;
      }
    }
  }
}
</style>
